import { useQuery } from "@tanstack/react-query";
import { fetchKarmacharis } from "../services/karmachariServices";

export const useFetchKarmachari = () => useQuery({
    queryKey: ['karmachari'],
    queryFn: fetchKarmacharis
})